import { render, staticRenderFns } from "./AddInvite.vue?vue&type=template&id=b2347666&"
import script from "./AddInvite.vue?vue&type=script&lang=js&"
export * from "./AddInvite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports